import PropTypes from "prop-types";
import { cn } from "@helpers/general";
import useResponsiveWithHydrationFix from "../../../hooks/useResponsiveWithHydrationFix";

import Timer from "../../Timer";

function AnnouncementBarTimer({ timer }) {
  const timerStyle = {
    borderColor: useResponsiveWithHydrationFix(
      timer?.borderColor?.mobile,
      timer?.borderColor?.desktop
    ),
    backgroundColor: useResponsiveWithHydrationFix(
      timer?.backgroundColor?.mobile,
      timer?.backgroundColor?.desktop
    ),
    textColor: useResponsiveWithHydrationFix(timer?.textColor?.mobile, timer?.textColor?.desktop),
  };

  const hasBorder = timer?.borderColor?.title && timer.borderColor.title !== "null";

  return (
    <div
      style={{
        borderColor: hasBorder ? timerStyle.borderColor : "",
        color: timer.textColor.title !== "null" ? timerStyle.textColor : "",
        backgroundColor: timer.backgroundColor.title !== "null" ? timerStyle.backgroundColor : "",
      }}
      className={cn(
        "typo-micro whitespace-nowrap",
        hasBorder && "rounded-[8px] ml-[10px] px-[13px]"
      )}
      data-testid="timer"
    >
      <Timer
        timerCountdown={timer.timerCountdown}
        timerStartDate={timer.timerStartDate}
        timerEndDate={timer.timerEndDate}
        cookieName="ab_timer"
      />
    </div>
  );
}

AnnouncementBarTimer.propTypes = {
  timer: PropTypes.shape({
    enabled: PropTypes.bool,
    backgroundColor: PropTypes.shape({
      title: PropTypes.string,
      mobile: PropTypes.string,
      desktop: PropTypes.string,
    }),
    borderColor: PropTypes.shape({
      title: PropTypes.string,
      mobile: PropTypes.string,
      desktop: PropTypes.string,
    }),
    textColor: PropTypes.shape({
      title: PropTypes.string,
      mobile: PropTypes.string,
      desktop: PropTypes.string,
    }),
  }),
};
export default AnnouncementBarTimer;
